module.exports = __webpack_public_path__ + "static/media/nav_links_hover.51731d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nav_links_hover.png
// module id = 248
// module chunks = 0